export default {
  navigation: {
    next: 'Suivant',
    back: 'Retour',
    surveyNavigation: 'Navigation du sondage',
    workspace: {
      home: 'Accueil',
      example: 'Exemple',
    },
  },
}
